export function timeToOffset(start, end, baseMinutes = 7 * 60) {
    const pxPerHalfHour = 48; // 30 min = 48px
    const visualOffset = 32;

    const toMinutes = time => {
        const [h, m] = time.split(':').map(Number);
        return h * 60 + m;
    };

    const startMin = toMinutes(start);
    let endMin = toMinutes(end);

    if (endMin <= startMin) {
        endMin += 24 * 60;
    }

    const top = ((startMin - baseMinutes) / 30) * pxPerHalfHour + visualOffset;
    const height = ((endMin - startMin) / 30) * pxPerHalfHour - 2;

    return { top, height };
}
